import BrmApiClient from "services/brm/BrmApiClient";
import { SystemApi, VariantApi, ModuleApi, MetadataApi } from "@kdmanalytics/brm-component";

export const systemApi = new SystemApi(BrmApiClient.instance);
export const variantApi = new VariantApi(BrmApiClient.instance);
export const moduleApi = new ModuleApi(BrmApiClient.instance);
export const metadataApi = new MetadataApi(BrmApiClient.instance);
